/*************************************************/
/* 3rd Party                                     */
/*************************************************/
window.$ = window.jQuery = require("jquery");

import { mmenu } from "./partials/mmenu.js";
import { inview } from "./partials/inview.js";
import bookingQueryKeys from './vue/booking/bookingQueryKeys.js';
import bfdl from './bookingFlowDataLayer.js';


/*************************************************/
/* Partials                                      */
/*************************************************/
import { video } from "./partials/video.js";
import { search } from "./partials/search.js";
import { accordions } from "./partials/accordions.js";
import { header } from "./partials/header.js";
import { banner } from "./partials/banner.js";
import { faq } from "./partials/faq.js";
import { collapsedText } from "./partials/collapsedText.js";
import { searchbar } from "./partials/searchbar.js";


/*************************************************/
/* Location Search                               */
/*************************************************/
import { createApp, h, ref } from 'vue';
import PrimeVue from 'primevue/config';
import LocationSearch from "./vue/locationSearch.vue";

const appLocationSearch = "#app-location-search";
if (document.querySelectorAll(appLocationSearch).length) {
    const seedData = {
        useAPI: false,
        showLocationButton: true
    };

    const locationSearch = createApp({
        render: () => h(LocationSearch)
    }, seedData);
    locationSearch.mount(appLocationSearch);

    locationSearch.use(PrimeVue);
}


/*************************************************/
/* Global variables                              */
/*************************************************/
const $body = $("body");

/*************************************************/
/* Init                                          */
/*************************************************/
$(document).ready(function () {
    mmenu();
    inview();
    video();
    accordions();
    header($body);
    search();
    banner();
    collapsedText();
    faq();
    searchbar($body);

    // var searchParams = new URLSearchParams(window.location.search);
    // const referrer = searchParams.get(bookingQueryKeys.referrer);
    const eventName = bfdl.getEventName(window.location.pathname);

    if(eventName != bfdl.events.findLagerFlow) {
        bfdl.pushToDataLayer(eventName, bfdl.steps.atOrigin);
    }

    $(document).on('click', '.departments__cards__show-hidden', function () {
        $(this).remove();
        $('.departments__cards').removeClass('departments__cards--hidden-cards');
        var flexFixElement = $('.flex-fix').clone();
        $('.flex-fix').hide();
        $('.departments__cards').append(flexFixElement);
    })

       //Handle scroll to submitted form element
       const formSubmittedElement = document.getElementById("umbraco-forms-form-submitted--clienti");
       if(formSubmittedElement){
           window.scrollTo(0,formSubmittedElement.closest('.form-item').offsetTop);
       }
   
       //Fire dataLayer event for forms submission
       const formSubmitMessage = document.querySelector('[class^="umbraco-forms-submitmessage"]');
       if(formSubmitMessage){
           window.dataLayer.push({
               'event': 'formSubmission',
               'formType':formSubmitMessage.dataset.formName
           });
       }
});
